import { useEffect, useState } from 'react'
import {
  Button,
  Card,
  Dropdown,
  FormControl,
  FormSelect,
  Table,
} from 'react-bootstrap'
import Pagination from '../reusable/Pagination'
import fetchData from '../utils/fetchData'
import formatDate from '../utils/formatDate'
import getCookie from '../utils/getCookie'
import { staticUrl } from '../utils/url'
import Add from './Add'
import Delete from './Delete'

const Type = () => {
  // ! hooks
  const [isModal, setModal] = useState(false)
  const [isEdit, setEdit] = useState(false)
  const [types, setTypes] = useState([])
  const [typeData, setTypeData] = useState()
  const [isDelete, setDelete] = useState(false)
  const [id, setId] = useState()
  // ! filter
  const [filter, setFilter] = useState({ search: '', status: '' })
  // ! pagination
  const [page, setPage] = useState(1)
  const [total, setTotal] = useState(0)
  const [limit, setLimit] = useState(10)

  // ! get types data
  const getTypes = async () => {
    try {
      const { data } = await fetchData.get(
        `/type?page=${page}&limit=${limit}&filter=${JSON.stringify(filter)}`,
        { headers: { Authorization: `Bearer ${getCookie('eyevaryToken')}` } }
      )
      setTotal(data?.total)
      setTypes(data?.types)
    } catch (error) {
      console.log({ ...error }, error)
    }
  }
  useEffect(() => {
    getTypes()
  }, [page, limit, filter])
  useEffect(() => {
    setPage(1)
  }, [filter])

  return (
    <section className='content-wrapper'>
      <Add
        isModal={isModal}
        setModal={setModal}
        isEdit={isEdit}
        setEdit={setEdit}
        setTypeData={setTypeData}
        typeData={typeData}
        getTypes={getTypes}
      />
      <Delete
        isModal={isDelete}
        setModal={setDelete}
        id={id}
        setId={setId}
        getTypes={getTypes}
      />
      <Card className='mb-4'>
        <Card.Body>
          <div className='d-flex flex-wrap align-items-center justify-content-between'>
            <Card.Title>Types</Card.Title>
            <div className='mb-3'>
              <Button size='sm' onClick={() => setModal(true)}>
                <i className='mdi mdi-plus me-1'></i> Add
              </Button>
            </div>
          </div>
          <div className='filter'>
            <div>
              <FormControl
                type='text'
                placeholder='Search'
                autoComplete='off'
                name='search'
                value={filter.search}
                onChange={({ target }) =>
                  setFilter({ ...filter, [target.name]: target.value })
                }
              />
            </div>
            <div>
              <FormSelect
                autoComplete='off'
                name='status'
                value={filter.status}
                onChange={({ target }) =>
                  setFilter({ ...filter, [target.name]: target.value })
                }>
                <option value=''>All</option>
                <option value='true'>Visible</option>
                <option value='false'>Hidden</option>
              </FormSelect>
            </div>
          </div>
          <Table className='text-nowrap' responsive>
            <thead>
              <tr>
                <th scope='col'>Type</th>
                <th scope='col'>Status</th>
                <th scope='col'>Published On</th>
                <th
                  scope='col'
                  style={{ maxWidth: '3rem', width: '3rem' }}></th>
              </tr>
            </thead>
            <tbody>
              {types?.map((type) => (
                <tr key={type?._id}>
                  <td className='align-middle'>
                    <div className='table-img'>
                      <img
                        src={type?.image ? staticUrl + type?.image : ''}
                        alt={type?.name}
                      />
                      <div>
                        <h6>{type?.name}</h6>
                        <p>Products & Services : {type?.productsServices}</p>
                      </div>
                    </div>
                  </td>
                  <td className='align-middle'>
                    {type?.status ? (
                      <span className='status status-outline-success'>
                        Visible
                      </span>
                    ) : (
                      <span className='status status-outline-danger'>
                        Hidden
                      </span>
                    )}
                  </td>
                  <td className='align-middle'>
                    {formatDate({
                      date: type?.createdAt,
                      divider: ' ',
                      time: true,
                    })}
                  </td>
                  <td className='align-middle text-center'>
                    <Dropdown>
                      <Dropdown.Toggle as='span' className='pnt'>
                        <i className='mdi mdi-dots-vertical'></i>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item
                          as='span'
                          className='pnt'
                          onClick={() => {
                            setEdit(true)
                            setModal(true)
                            setTypeData(type)
                          }}>
                          Edit
                        </Dropdown.Item>
                        <Dropdown.Item
                          as='span'
                          className='pnt'
                          onClick={() => {
                            setDelete(true)
                            setId(type?._id)
                          }}>
                          Delete
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <Pagination
            page={page}
            setPage={setPage}
            total={total}
            limit={limit}
          />
        </Card.Body>
      </Card>
    </section>
  )
}

export default Type
